import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-card-forbidden',
  imports: [SHARED_MODULES],
  templateUrl: './card-forbidden.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardForbiddenComponent {
  protected readonly forbidden = input<Record<string, any>>();

  public label(validation: string): string {
    return `geral.guards.${validation}`;
  }
}
